var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.78,
    height: 68.647,
    viewBox: "0 0 83.78 68.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{stroke:#2A7DE1;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-516.72 -573.761)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(516.72 573.761)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.653,36.173a25.4,25.4,0,0,0,.195-3.036,19.2,19.2,0,0,0-.234-3.036l6.578-5.138a1.608,1.608,0,0,0,.389-1.985L56.353,12.2a1.583,1.583,0,0,0-1.907-.7L46.7,14.611a22.8,22.8,0,0,0-5.254-3.036L40.279,3.323A1.554,1.554,0,0,0,38.722,2H26.267a1.515,1.515,0,0,0-1.518,1.323l-1.168,8.251a23.413,23.413,0,0,0-5.254,3.036L10.581,11.5a1.539,1.539,0,0,0-1.907.7L2.447,22.979a1.508,1.508,0,0,0,.389,1.985L9.414,30.1a18.343,18.343,0,0,0-.039,6.072L2.8,41.311A1.608,1.608,0,0,0,2.408,43.3L8.635,54.077a1.583,1.583,0,0,0,1.907.7l7.745-3.114A22.8,22.8,0,0,0,23.542,54.7l1.168,8.251a1.583,1.583,0,0,0,1.557,1.323H38.722a1.487,1.487,0,0,0,1.518-1.323L41.407,54.7a23.414,23.414,0,0,0,5.254-3.036l7.745,3.114a1.539,1.539,0,0,0,1.907-.7L62.542,43.3a1.508,1.508,0,0,0-.389-1.985l-6.5-5.138ZM32.494,44.814A11.677,11.677,0,1,1,44.171,33.137,11.711,11.711,0,0,1,32.494,44.814Z",
    transform: "translate(-2.222 -2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.807 10.434)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 21.886,
    height: 27.357,
    rx: 10.943,
    transform: "translate(10.943)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.736,0A21.736,21.736,0,0,1,43.473,21.736c0,6.8-43.473,6.3-43.473,0A21.736,21.736,0,0,1,21.736,0Z",
    transform: "translate(0 30.062)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigManagement);
export default __webpack_public_path__ + "static/media/configManagement.c9b18ce5baebcdf2a6d8453a61884800.svg";
export { ForwardRef as ReactComponent };